// import React, { useEffect } from 'react';
// import { Provider } from 'react-redux';
// import { BrowserRouter as Router, Routes, Route,useLocation  } from 'react-router-dom';
// import store from './store/store';
// import routes from './routes/routes';
// import Header from './components/layout/Header';
// import Footer from './components/layout/Footer';
// import PrivateRoute from './routes/PrivateRoute';
// if (process.env.NODE_ENV === "production") {
//   console.log = () => {};
//   console.warn = () => {};
//   console.error = () => {};
// }
// const App = () => {
//   // useEffect(() => {
//   //   if (window.location.protocol === 'http:') {
//   //     window.location.href = window.location.href.replace('http:', 'https:');
//   //   }
//   // }, []);
//   const location = useLocation();
//   const hideFooterPaths = ["/", "/home"];

//   const shouldHideFooter = hideFooterPaths.includes(location.pathname);
//   return (

//     <Provider store={store}>
//       <Router>
//         <Header />
//         <main>
//           <Routes>
//             {routes.map((route, index) => {
//               const { path, element: Component, private: isPrivate } = route;
//               return (
//                 <Route
//                   key={index}
//                   path={path}
//                   element={
//                     isPrivate ? (
//                       <PrivateRoute>
//                         <Component />
//                       </PrivateRoute>
//                     ) : (
//                       <Component />
//                     )
//                   }
//                 />
//               );
//             })}
//           </Routes>
//         </main>
//         {!shouldHideFooter && <Footer />}
//       </Router>
//     </Provider>
//   );
// };

// export default App;
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import store from './store/store';
import routes from './routes/routes';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import PrivateRoute from './routes/PrivateRoute';

if (process.env.NODE_ENV === "production") {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
}

// Component con phải nằm bên trong <Router> để dùng useLocation()
function AppContent() {
  const location = useLocation();
  const hideFooterPaths = ["/", "/home"];
  const shouldHideFooter = hideFooterPaths.includes(location.pathname);

  return (
    <>
      <Header />
      <main>
        <Routes>
          {routes.map((route, index) => {
            const { path, element: Component, private: isPrivate } = route;
            return (
              <Route
                key={index}
                path={path}
                element={
                  isPrivate ? (
                    <PrivateRoute>
                      <Component />
                    </PrivateRoute>
                  ) : (
                    <Component />
                  )
                }
              />
            );
          })}
        </Routes>
      </main>

      {!shouldHideFooter && <Footer />}
    </>
  );
}

const App = () => {
  // useEffect(() => {
  //   if (window.location.protocol === 'http:') {
  //     window.location.href = window.location.href.replace('http:', 'https:');
  //   }
  // }, []); 
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
};

export default App;
